<!-- eslint-disable max-len -->
<template>
  <div>
    <v-row class="mt-8" v-if="!!docSignDialog">
      <v-col
        class="d-flex justify-center"
      >
        <!-- <img style="height: 100px" :src="`${hostPath}/landrum-logo-darkv3.png`" alt=""> -->
        <!-- https://assets.landrumhr.com/logos/Solutions-Color.png -->
        <img style="height: 100px" src="https://assets.landrumhr.com/logos/Solutions-Color.png" alt="">
      </v-col>
    </v-row>
    <v-dialog
      v-model="docSignDialog"
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirm Email</span>
        </v-card-title>
        <v-card-subtitle>In order to sign the document please confirm you are the intended recipient by inputting your email into the text box below and clicking 'Submit'</v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="enteredEmail"
            placeholder="john.doe@example.com"
            @keyup.enter="checkEmail"
            v-bind="{
              error: !!errorMessage,
              ...(!!errorMessage && { 'error-messages': [ 'Incorrect email. Please enter the email associated with the signature request.' ] })
            }"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="checkEmail"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <docuseal-form
      :data-src="embedSrc"
      :data-email="email"
      data-with-title="false"
      data-with-download-button="false"
      data-with-send-copy-button="false"
      data-allow-to-resubmit="false"
      data-logo="https://assets.landrumhr.com/logos/Solutions-Color.png"
      :data-custom-css="$vuetify.theme.dark ? darkModeCSS : ''"
    ></docuseal-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DocSign',
  data: () => ({
    verifiedEmail: false,
    embedSrc: null,
    enteredEmail: null,
    errorMessage: false,
    darkModeCSS: 'div.ds div.text-center.font-semibold { color: white; }',
  }),
  watch: {
    enteredEmail() {
      this.errorMessage = false;
    },
  },
  created() {
    const darkMode = localStorage.getItem('darkMode');

    if (darkMode !== null && typeof (darkMode) === 'string') {
      this.$vuetify.theme.dark = (darkMode === 'true');
    } else {
      this.$vuetify.theme.dark = false;
    }
  },
  mounted() {
    document.querySelector('docuseal-form').addEventListener('completed', this.onFormComplete);

    if (this.docSignDialog === false) {
      this.checkEmail();
    }
  },
  computed: {
    hostPath() {
      return process.env.VUE_APP_PUBLIC;
    },
    email() {
      if (this.enteredEmail) {
        return this.enteredEmail;
      }
      if (this.$store.state.docSignEmail) {
        return this.$store.state.docSignEmail;
      }

      return null;
    },
    docSignDialog() {
      return this.$store.state.docSignDialog;
    },
  },
  methods: {
    onFormComplete(data) {
      this.updateSignatureDate(data.detail.completed_at);
    },
    checkEmail() {
      const params = `&documentId=${this.$route.params.id}&email=${encodeURIComponent(this.email)}`;
      axios.get(`${process.env.VUE_APP_SERVER}/register/getSigningUrl?${params}`)
        .then((response) => {
          if (response.status === 200 && response.data === 'Email does not match') {
            this.errorMessage = true;
          } else {
            this.embedSrc = response.data.url;
            this.$store.commit('updateDocSignDialog', false);
            this.verifiedEmail = true;
          }
        });
    },
    updateSignatureDate(completedAt) {
      // eslint-disable-next-line max-len
      const params = `documentId=${this.$route.params.id}&email=${encodeURIComponent(this.email)}&completedAt=${completedAt}`;
      axios.put(`${process.env.VUE_APP_SERVER}/register/markAsSigned?${params}`).then((response) => {
        if (this.$store.state.prospectPacket !== null) {
          if (response.data.registrationStatus === 'Signed') {
            this.$store.commit('updateProspectStateStatus', response.data.registrationStatus);
            this.$router.push({ name: 'ThankYou' });
          }

          if (response.data.benefitStatus === 'Signed') {
            this.$store.commit('updateBenefitsStateStatus', response.data.benefitStatus);
            this.$router.push({ name: 'ThankYou' });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
